import * as BABYLON from '@babylonjs/core';
import '@babylonjs/loaders';
import MeshObject from "./MeshObject";

export default class BabylonObject extends MeshObject
{
    constructor(scene, filename, name, options)
    {
        super(scene, name, options);


        this.animation = false;
        this.loaded = false;
        this.callback = false;
        this.trigger = options.trigger;

        let self = this;

        /* Async
        BABYLON.SceneLoader.ImportMeshAsync("", "/3d-models/", filename, this.scene)
            .then( function (result) // eslint-disable-line no-unused-vars
            {
                let newMeshes = result.meshes;
                let particleSystems = result.particleSystems;
                let skeletons = result.skeletons;
                let animationsGroup = result.animationGroups;
         */

        let path = process.env.VUE_APP_FOLDER + (process.env.VUE_APP_FOLDER.slice(-1) === '/' ? '' : '/') + "3d-models/";
        BABYLON.SceneLoader.ImportMesh("", path, filename, this.scene,
            function (newMeshes, particleSystems, skeletons, animationsGroup) // eslint-disable-line no-unused-vars
            {
                let obj = new BABYLON.TransformNode(name);

                for (var i = 0; i < newMeshes.length; i++)
                {
                    newMeshes[i].parent = obj;

                    // Action Trigger
                    if (self.trigger)
                    {
                        newMeshes[i].actionManager = new BABYLON.ActionManager(self.scene);
                        newMeshes[i].actionManager.registerAction(
                            new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function ()
                            {
                                self.trigger();
                            })
                        );
                    }
                }

                if (animationsGroup && animationsGroup.length)
                {
                    self.animation = animationsGroup[0];
                    if (self.animation.isStarted)
                    {
                        self.animation.stop();
                    }
                }

                self.node = obj;

                self.initChilds();

                self.setState(self.options);

                if (self.options.callback)
                {
                    self.options.callback(self, newMeshes, particleSystems, skeletons, animationsGroup);
                }

                if (self.callback)
                {
                    self.callback(self, newMeshes, particleSystems, skeletons, animationsGroup);
                }

                self.loaded = true;
            }
        );
    }

    runStateFunctions(newState)
    {
        // Animation
        if (newState.hasOwnProperty('animation') && this.currentState.animation !== newState.animation)
        {
            if (newState.animation)
            {
                this.animation.start(false);
                this.animation.speedRatio = 0.25;
            }
            else
            {
                this.animation.start(false);
                this.animation.goToFrame(0);
                this.animation.stop();
            }
        }

        super.runStateFunctions(newState);
    }
}
